import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AspLoadingService } from '../asp-loading/asp-loading.service';
import { AspCartService } from '../asp-cart/asp-cart.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Location } from '@angular/common';
import { AspSlotDeliveryService } from './asp-slot-delivery.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { GlobalVariable } from 'app/main/globals';

@Component({
  selector: 'app-asp-slot-delivery',
  templateUrl: './asp-slot-delivery.component.html',
  styleUrls: ['./asp-slot-delivery.component.scss']
})
export class AspSlotDeliveryComponent implements OnInit {
  upcoming: boolean;
  isSelected: boolean;
  isPickUp: boolean;
  isInstant: boolean;
  step3: boolean;
  data: any;
  sparesDiscount: number;
  cartSubTotal: number;
  cartGrandTotal: number;
  shippingCharges: any;
  avoidShippingCharges: any;
  redeemCart: string;
  slotData: any;
  urgent: boolean;
  freeShipping: boolean;
  countdown: string = '00:00:00';
  intervalId: any;
  mapImageUrl: string;

  constructor(
    private aspLoadingService: AspLoadingService,
    private aspCartService: AspCartService,
    private bottomSheet: MatBottomSheet,
    private location: Location,
    private aspSlotDeliveryService: AspSlotDeliveryService,
    private router: Router,   
    private toastr: ToastrService, 
  ) { }

  @ViewChild('bottomSheetTemplate') bottomSheetTemplate!: TemplateRef<any>;

  ngOnInit(): void {
      const state = window.history.state;
        console.log('💡 slot state:', state);
            if (state.step3) {
              this.selectSlot(2);
              this.step3 = state.step3 ?? false;
    }
    if (state?.isSelected && state?.slotId) {
      this.selectSlot(state.slotId);
    }
         if(localStorage.getItem('instantOrderPay')== 'true'){
    this.data=JSON.parse(sessionStorage.getItem('instantOrder'))
      const cartCountEl = document.getElementsByClassName('animate-cta')[0] as HTMLElement;
      cartCountEl.style.display = 'none';
    }else{
      this.data=JSON.parse(sessionStorage.getItem('orderData'))
    } 
    this.getCart();
    this.getSlots();
  }
 getCart(){
    if(this.data){    
      let cartData;  
      // this.cartList = [];
      this.cartSubTotal = 0;
      this.sparesDiscount = 0;
      cartData = this.data;
      Object.values(cartData[0]).forEach(cart => { 
        this.cartSubTotal += (cart['mrp']*cart['cart_qty']);
        this.sparesDiscount += (cart['discount']*cart['cart_qty']);
        
        // this.cartList.push(cart);
      });

      if(this.sparesDiscount>0){
        this.cartGrandTotal = (this.cartSubTotal - this.sparesDiscount);
      }else{
        this.cartGrandTotal = this.cartSubTotal;
      }

    }
    this.getShippingCharges();
  }
  getSlots(){
    let dataRaw;
 if(localStorage.getItem('instantOrderPay')== 'true'){
    dataRaw=sessionStorage.getItem('instantOrder')
      const cartCountEl = document.getElementsByClassName('animate-cta')[0] as HTMLElement;
      cartCountEl.style.display = 'none';
    }else{
      dataRaw=sessionStorage.getItem('orderData')
    } 

    const parsed = JSON.parse(dataRaw); // Parse the full JSON string

const partKeysArray = Object.keys(parsed[0]);

    this.aspLoadingService.show();
      this.aspSlotDeliveryService.getSlotData(partKeysArray).subscribe(
     res => {
          if(res['code']==200){
          this.aspLoadingService.hide();
          this.slotData=res['data'];
          this.startCountdown();
          const lat = this.slotData.wareHouseData[0].latitude ;
          const lng = this.slotData.wareHouseData[0].longitude ;

          this.mapImageUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&zoom=15&size=600x300&markers=color:red%7C${lat},${lng}&key=${GlobalVariable.GOOGLE_STATIC_MAP_KEY}`;

        console.log("res", res);
          }else{
            
          this.toastr.error(res['message'], 'No spare parts found for the provided identifiers');
          this.aspLoadingService.show();
          }
      });


  }

  getDeliveryLabel(date): string {
    const now = new Date();
    const deliveryDate = new Date(date);

    // Strip time for comparison
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const deliveryDay = new Date(deliveryDate.getFullYear(), deliveryDate.getMonth(), deliveryDate.getDate());

    const diffInTime = deliveryDay.getTime() - today.getTime();
    const diffInDays = diffInTime / (1000 * 3600 * 24);

    const time = deliveryDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

    if (diffInDays === 0) {
      return `Today by ${time}`;
    } else if (diffInDays === 1) {
      return `Tomorrow by ${time}`;
    } else {
      return `On ${deliveryDate.toLocaleDateString()} by ${time}`;
    }
  }
  getShippingCharges(){    
    this.aspLoadingService.show();  
    let garageKey = localStorage.getItem('garageKey');
    console.log("cartGrandTotal",this.cartGrandTotal);
    this.aspCartService.getShippingCharges(this.cartGrandTotal, garageKey).subscribe(
      result => {
      //  this.getWalletData()
        let res = JSON.parse(JSON.stringify(result)); 
        if(res.code==200){
          // this.shippingChargesApplicable = res.data.shippingChargesApplicable;
          this.shippingCharges = res.data.shippingCharges;
          this.avoidShippingCharges = res.data.avoidShippingCharges;
          this.aspLoadingService.hide();
          // if(this.shippingChargesApplicable && this.cartSubTotal<=this.avoidShippingCharges){
            // this.cartGrandTotal = (this.cartGrandTotal+this.shippingCharges);
            // this.cartGrandTotal1=(this.cartGrandTotal+this.shippingCharges);
          // }
        } else {
          console.log("Unexpected response code:", res.code);  // Log if the response code is not 200
        }
      }
    );
  }

  openBottomSheet(): void {
    this.bottomSheet.open(this.bottomSheetTemplate,{
     panelClass: 'custom-bottom-sheet1'
    }
    );
  }


  closeBottomSheet(): void {
    if (this.bottomSheet) {
      this.bottomSheet.dismiss();
    }
  }


  upcomingSlots(){
    this.isSelected = true;
    this.upcoming=!this.upcoming;
  }
  selectSlot(num){
    this.freeShipping=false;
    if(num==1){
      this.isPickUp=false;
      this.isInstant=false;
      this.isSelected=!this.isSelected;
      this.urgent=false;
    }
    if(num==2){
      this.isPickUp=!this.isPickUp;
      this.isInstant=false;
      this.isSelected=false;
    }
    if(num==3){
      this.isPickUp=false;
      this.isInstant=!this.isInstant;
      this.isSelected=false;
    }
  }
  goToNext(){
    this.step3=true;
    this.isPickUp=true;
    this.isSelected=false;
    this.isInstant=false;
  }
  backToPrevious(){
     this.step3=false;
  }
  changeDelivery(){
      this.step3=false;
     this.freeShipping=false;
    this.isPickUp=false;
    this.isSelected=false;
    this.isInstant=false;
  }
    goBack(): void {
    if(localStorage.getItem('instantOrderPay')== 'true'){
      this.location.back();
      }else{
    this.router.navigate(['cart']);
      }
  }

  //   address: string = 'Kuvempunagara ( BTM Layout), Old Madiwala, Jay Bheema Nagar, 1st Stage, BTM Layout, Bengaluru, Karnataka 560068';

  // openMap(): void {
  //   const encodedAddress = encodeURIComponent(this.address);
  //   const mapUrl = `https://www.google.com/maps?q=${encodedAddress}`;
  //   window.open(mapUrl, '_blank'); // opens in new tab
  // }
openMap(): void {
  const lat = this.slotData.wareHouseData[0].latitude ;
  const lng = this.slotData.wareHouseData[0].longitude ;

  const mapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}&travelmode=driving`;

  window.open(mapsUrl, '_blank');
  this.freeShipping=false;
}

  proceedInstant(slotid, name, warehouseName=''){
  console.log("slotId",slotid);
  if(name=='instantDelivery'){
    this.urgent=true;
  }else{
    this.goToPayment(slotid, name, warehouseName);
  }
  }
getUpcoming(dateString: string): string {
  const now = new Date();
  const deliveryDate = new Date(dateString);

  // Strip time for comparison
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const deliveryDay = new Date(deliveryDate.getFullYear(), deliveryDate.getMonth(), deliveryDate.getDate());

  const diffInDays = (deliveryDay.getTime() - today.getTime()) / (1000 * 3600 * 24);

  const hours = deliveryDate.getHours();
  const minutes = deliveryDate.getMinutes();

  const isPM = hours >= 12;
  const hour12 = hours % 12 === 0 ? 12 : hours % 12;
  const minutesFormatted = minutes < 10 ? '0' + minutes : minutes;
  const timeFormatted = `${hour12}:${minutesFormatted} ${isPM ? 'PM' : 'AM'}`;

  if (diffInDays === 0) {
    return `Today ${timeFormatted}`;
  } else if (diffInDays === 1) {
    return `Tomorrow ${timeFormatted}`;
  } else {
    const dateFormatted = deliveryDate.toLocaleDateString(); // You can customize this
    return `${dateFormatted} ${timeFormatted}`;
  }
}


goToPayment(slotid, name, warehouseName=''){
  // console.log("slotid",slotid);
  localStorage.setItem("slotid",slotid);
  localStorage.setItem("slotName",name);
  if(warehouseName){
    localStorage.setItem("slotWarehouseName",warehouseName);
  }
  this.router.navigate(['payment']);
}
openPickup(){
  this.freeShipping=!this.freeShipping;
}


startCountdown() {
  const minutesFromNow = Number(this.slotData?.currentSlot?.orderConfirmTime);

  if (isNaN(minutesFromNow)) {
    console.error('Invalid orderConfirmTime value:', minutesFromNow);
    return;
  }

  // Target time = now + minutesFromNow
  const confirmTime = new Date().getTime() + minutesFromNow * 60 * 1000;

  this.intervalId = setInterval(() => {
    const now = new Date().getTime();
    let diff = Math.max(confirmTime - now, 0); // Milliseconds left

    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    this.countdown =
      this.pad(hours) + ':' +
      this.pad(minutes) + ':' +
      this.pad(seconds);

    if (diff <= 0) {
      clearInterval(this.intervalId);
      this.countdown = '00:00:00';
    }
  }, 1000);
}

pad(num: number): string {
  return num < 10 ? '0' + num : num.toString();
}

ngOnDestroy() {
  if (this.intervalId) {
    clearInterval(this.intervalId);
  }
}
convertMinutesToTimeLabel(totalMinutes: number): string {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  const h = hours > 0 ? `${hours}h` : '';
  const m = minutes > 0 ? `${minutes}m` : '';

  return `${h} ${m}`.trim(); // Removes extra space if minutes = 0
}
}
